
















import { Vue, Component } from 'vue-property-decorator'
import Card from '@/components/PaymentWrapper.vue'
import Title from '@/components/PageTitle.vue'
import { Action, State } from 'vuex-class'
import { Payment, Step } from '../store'

const types = Object.freeze(['creditcard',
  'unionPay',
  'shop',
  'webAtm',
  'atm'])

@Component({
  components: { Card, Title }
})
export default class PaymentSelect extends Vue {
  private pms = types.map((e, i) => ({ index: i, card: e }))
  private mainPayment = ''

  @State('payment') payment!: Payment
  @Action('stepTo') stepTo!: Function
  @Action('setPayment') setPayment!: (payment: Payment) => void
  @Action('setMainPayment') setMainPayment!: (mp: string) => void

  cardOnClick (card: string) {
    if (~['unionPay', 'creditcard'].indexOf(card)) {
      this.setPayment(Payment.CreditCard)
    } else if (card === 'shop') {
      this.setPayment(Payment.Shop)
    } else {
      this.setPayment(Payment.WebATM)
    }
    this.setMainPayment(card)
    this.mainPayment = card
  }
  mounted () {
    this.stepTo(Step.Select)
  }

  routerTo () {
    if (this.payment === Payment.CreditCard) {
      this.$router.push({ name: 'creditcard' })
    } else if (this.payment === Payment.Shop) {
      this.$router.push({ name: 'shop' })
    } else {
      this.$router.push({ name: 'web-atm' })
    }
  }
}
